export const adapt = () => {
  const activeObject = window.canvas.getActiveObject();
  const imageAspectRatio = activeObject.width / activeObject.height;
  const canvasAspectRatio = window.canvas.width / window.canvas.height;

  if (imageAspectRatio > canvasAspectRatio) {
    activeObject.scaleToWidth(window.canvas.width);
  } else {
    activeObject.scaleToHeight(window.canvas.height);
  }

  activeObject.center();
  activeObject.centerV();
};
